import React from 'react';
import { Leaf, CheckCircle, TrendingUp, BookOpen, Users, Shield } from 'lucide-react';

import Breadscrumbs from './Breadscrumbs';

import mission_img from "../assets/images/mission.png";
import vision_img from "../assets/images/vision.png";
import value_img from "../assets/images/value.png";
import service_img from "../assets/images/service.png";

const coreValues = [
    { title: "Tin cậy", description: "Đặt sự minh bạch, chính xác và trung thực trong từng con số, báo cáo và giải pháp." },
    { title: "Công bằng", description: "Cam kết không bỏ lại ai phía sau, đặc biệt là các cộng đồng dễ bị tổn thương bởi biến đổi khí hậu." },
    { title: "Sáng tạo & Cập nhật", description: "Liên tục đổi mới, học hỏi và ứng dụng các phương pháp, công nghệ, tiêu chuẩn quốc tế." },
    { title: "Trách nhiệm bền vững", description: "Mọi hành động đều hướng đến lợi ích lâu dài cho môi trường, xã hội và thế hệ tương lai." },
    { title: "Đồng hành", description: "Không chỉ là nhà tư vấn, VeraLeaf là bạn đồng hành tận tâm của cả doanh nghiệp và cộng đồng." }
];

const aboutItems = [
    {
      title: "Về VeraLeaf",
      description:
        "VeraLeaf là một công ty trẻ, hoạt động trong lĩnh vực tư vấn kiểm kê khí nhà kính (KNK), thẩm tra, thẩm định báo cáo phát thải, và xây dựng các giải pháp giảm phát thải hiệu quả theo định hướng phát triển xanh.",
    },
    {
      title: "Đội ngũ khoa học",
      description:
        "VeraLeaf là nơi hội tụ của nhóm các nhà khoa học trẻ, với mục tiêu xây dựng và triển khai các dự án hỗ trợ cộng đồng, thúc đẩy các mục tiêu phát triển bền vững (SDG).",
    },
    {
      title: "Giải pháp bền vững",
      description:
        "Thông qua các hoạt động nghiên cứu, đào tạo và chuyển giao giải pháp, VeraLeaf đồng hành cùng cộng đồng hướng đến sự phát triển bền vững.",
    },
    {
      title: "Ý nghĩa tên gọi",
      description:
        "Tên gọi VeraLeaf – 'chiếc lá tin cậy' – là sự kết hợp giữa giá trị chính trực, công bằng (Vera) và biểu tượng của sự sống, phát triển xanh (Leaf).",
    },
  ];


const activityItems = [
  { icon: <Leaf className="w-8 h-8 text-600" />, title: "Kiểm kê KNK", description: "Tư vấn kiểm kê khí nhà kính (KNK) và lập báo cáo phát thải." },
  { icon: <CheckCircle className="w-8 h-8 text-600" />, title: "Thẩm tra KNK", description: "Thẩm tra và thẩm định báo cáo KNK." },
  { icon: <TrendingUp className="w-8 h-8 text-600" />, title: "Giải pháp Net Zero", description: "Giải pháp giảm phát thải hướng tới Net Zero." },
  { icon: <Users className="w-8 h-8 text-600" />, title: "Dự án cộng đồng", description: "Dự án cộng đồng thích ứng với biến đổi khí hậu." },
  { icon: <BookOpen className="w-8 h-8 text-600" />, title: "Nghiên cứu & sáng kiến", description: "Nghiên cứu và sáng kiến bền vững." },
  { icon: <Shield className="w-8 h-8 text-600" />, title: "Đào tạo & truyền thông", description: "Đào tạo - Truyền thông - Nâng cao nhận thức." },
];

const IntroductionPage = () => {
    return (
    <div>
        <Breadscrumbs title="Giới thiệu" />

        {/* About Section */}
        <section className="py-12 border-t bg-gray-50">
          <div className="max-w-6xl mx-auto px-4 md:px-8">
                <div className="text-center mb-8">
                <h3 className="text-2xl font-semibold text-700">Về VeraLeaf</h3> 

                  <p className="text-gray-700 text-base leading-relaxed max-w-3xl mx-auto mt-4">
                    Trong bối cảnh biến đổi khí hậu ngày càng gia tăng và mục tiêu đạt phát thải ròng bằng “0” (Net Zero) đang trở thành cam kết toàn cầu, Việt Nam đang từng bước siết chặt các quy định và thúc đẩy các hành động thực chất để giảm thiểu khí nhà kính. Đồng hành cùng tiến trình này, VeraLeaf được thành lập như một tổ chức tư vấn chuyên sâu, góp phần tạo ra các chuyển đổi bền vững và công bằng cho xã hội.
                  </p>
                </div>


            <div className="grid md:grid-cols-4 gap-6">
              {aboutItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition"
                >
                  <h4 className="text-lg font-semibold text-700 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Mission Section */}
        <section className="bg-gray-100 py-12 border-t">
            <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-start">
                <div className="flex flex-col items-center md:items-start text-center md:text-left">
                    <img src={mission_img} alt="Mission Icon" className="w-24 h-24 object-contain mb-4" />
                    <h3 className="text-2xl font-semibold text-700">Sứ Mệnh</h3>
                </div>

                <div>
                    <p className="text-gray-700 leading-relaxed">
                        VeraLeaf cam kết đồng hành cùng doanh nghiệp và cộng đồng trong hành trình hướng đến phát triển carbon thấp, thích ứng với biến đổi khí hậu và thực hiện các mục tiêu phát triển bền vững. Chúng tôi cung cấp các giải pháp tư vấn, đào tạo và nghiên cứu mang tính thực tiễn – với trọng tâm là minh bạch, hiệu quả và công bằng cho cả con người và môi trường.
                    </p>
                </div>

            </div>
        </section>

        {/* Vision Section */}
        <section className="py-12 border-t">
          <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-center">
            <div className="order-2 md:order-1">
              <p className="text-gray-700 leading-relaxed">
                Trở thành đơn vị tiên phong tại Việt Nam trong lĩnh vực tư vấn kiểm kê và giảm phát thải khí nhà kính, cũng như phát triển các dự án hỗ trợ cộng đồng dễ bị tổn thương thích ứng hiệu quả với biến đổi khí hậu – góp phần xây dựng một tương lai xanh, công bằng và bền vững.
              </p>
            </div>
            <div className="order-1 md:order-2 flex flex-col items-center md:items-end text-center md:text-right">
              <img src={vision_img} alt="Vision Icon" className="w-24 h-24 object-contain mb-4" /> 
              <h3 className="text-2xl font-semibold text-700">Tầm Nhìn</h3>
            </div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="bg-gray-100 py-12 border-t">
          <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-center">
            <div className="flex flex-col justify-center items-center md:items-start text-center md:text-left h-full">
              <img
                src={value_img}
                alt="Core Values Icon"
                className="w-24 h-24 object-contain mb-4"
              />
              <h3 className="text-2xl font-semibold text-700">Giá Trị Cốt Lõi</h3>
            </div>
            <div className="flex flex-col space-y-4">
              {coreValues.map((value, index) => (
                <div key={index} className="flex items-start p-4 bg-white rounded-xl shadow-sm">
                  <div className="flex-shrink-0">
                    <span className="inline-block w-3 h-3 mt-1 bg-green-500 rounded-full"></span>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold text-700 mb-1">{value.title}</h4>
                    <p className="text-gray-700 text-sm leading-relaxed">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Activity Section */}
        <section className="bg-white py-12 border-t">
          <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-center">
            <div className="flex flex-col md:items-start items-center text-center md:text-left">
              <img src={service_img} alt="Activity Icon" className="w-24 h-24 object-contain mb-4" />
              <h3 className="text-2xl font-semibold text-700">Lĩnh Vực Hoạt Động</h3>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {activityItems.map((item, index) => (
                <div key={index} className="flex flex-col p-4 bg-gray-50 border rounded-xl shadow-sm hover:shadow-md transition">
                  <div>{item.icon}</div>
                  <h4 className="font-semibold text-700 mt-2">{item.title}</h4>
                  <p className="text-gray-700 text-sm mt-1">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

    </div>
    );
};

export default IntroductionPage;

